import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function TermsAndConditions() {
  const locale = sessionStorage.getItem('versant_locale') || 'en';

  const translations = {
    en: {
      title: "Terms and Conditions",
      welcome: "Welcome to Versant Practice Test. If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern our relationship with you in relation to this website.",
      h1: "1. Use of the Website",
      p1: "The content of the pages of this website is for your general information and use only. It is subject to change without notice.",
      h2: "2. User Account",
      p2: "To access certain features of the website, you may be required to create an account. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer.",
      h3: "3. Intellectual Property",
      p3: "This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.",
      h4: "4. Disclaimer",
      p4: "The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.",
      h5: "5. Limitation of Liability",
      p5: "In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website.",
      h6: "6. Governing Law",
      p6: "Your use of this website and any dispute arising out of such use of the website is subject to the laws of our country."
    },
    es: {
      title: "Términos y Condiciones",
      welcome: "Bienvenido a Versant Practice Test. Si continúa navegando y utilizando este sitio web, acepta cumplir y estar sujeto a los siguientes términos y condiciones de uso, que junto con nuestra política de privacidad rigen nuestra relación con usted en relación con este sitio web.",
      h1: "1. Uso del Sitio Web",
      p1: "El contenido de las páginas de este sitio web es solo para su información general y uso. Está sujeto a cambios sin previo aviso.",
      h2: "2. Cuenta de Usuario",
      p2: "Para acceder a ciertas funciones del sitio web, es posible que se le solicite crear una cuenta. Usted es responsable de mantener la confidencialidad de su cuenta y contraseña.",
      h3: "3. Propiedad Intelectual",
      p3: "Este sitio web contiene material que es de nuestra propiedad o está licenciado para nosotros. Este material incluye, pero no se limita a, el diseño, la presentación, el aspecto y los gráficos. Queda prohibida su reproducción.",
      h4: "4. Descargo de Responsabilidad",
      p4: "Los materiales de este sitio web se proporcionan 'tal cual'. No ofrecemos garantías, expresas o implícitas, y por la presente descuidamos y negamos cualquier otra garantía.",
      h5: "5. Limitación de Responsabilidad",
      p5: "En ningún caso nosotros o nuestros proveedores seremos responsables de los daños que surjan del uso o la imposibilidad de usar los materiales en nuestro sitio web.",
      h6: "6. Ley Aplicable",
      p6: "Su uso de este sitio web y cualquier disputa que surja de dicho uso del sitio web está sujeto a las leyes de nuestro país."
    },
    pt: {
      title: "Termos e Condições",
      welcome: "Bem-vindo ao Versant Practice Test. Se você continuar a navegar e usar este site, concorda em cumprir e estar vinculado aos seguintes termos e condições de uso, que junto com nossa política de privacidade regem nossa relação.",
      h1: "1. Uso do Site",
      p1: "O conteúdo das páginas deste site é apenas para sua informação geral e uso. Está sujeito a alterações sem aviso prévio.",
      h2: "2. Conta do Usuário",
      p2: "Para acessar determinados recursos do site, pode ser necessário criar uma conta. Você é responsável por manter a confidencialidade de sua conta e senha.",
      h3: "3. Propriedade Intelectual",
      p3: "Este site contém material que é de nossa propriedade ou licenciado para nós. Este material inclui, mas não se limita a, design, layout, aparência e gráficos.",
      h4: "4. Isenção de Responsabilidade",
      p4: "Os materiais neste site são fornecidos 'como estão'. Não oferecemos garantias, expressas ou implícitas, e por meio deste renunciamos a todas as outras garantias.",
      h5: "5. Limitação de Responsabilidade",
      p5: "Em nenhum caso nós ou nossos fornecedores seremos responsáveis por quaisquer danos decorrentes do uso ou da incapacidade de usar os materiais em nosso site.",
      h6: "6. Lei Aplicável",
      p6: "O uso deste site e qualquer disputa decorrente de tal uso estão sujeitos às leis do nosso país."
    },
    ja: {
      title: "利用規約",
      welcome: "Versant Practice Testへようこそ。当ウェブサイトの閲覧および利用を継続される場合は、以下の利用規約を遵守し、これに拘束されることに同意したものとみなされます。",
      h1: "1. ウェブサイトの利用",
      p1: "当ウェブサイトのコンテンツは、一般的な情報提供および利用のみを目的としています。予告なしに変更されることがあります。",
      h2: "2. ユーザーアカウント",
      p2: "特定の機能を利用するためにアカウントの作成が必要な場合があります。パスワードの機密保持およびアカウントの管理はお客様の責任で行ってください。",
      h3: "3. 知的財産権",
      p3: "当サイトに掲載されている素材（デザイン、レイアウト、外観、画像など）は、当サイトに帰属またはライセンスされています。無断転載・複製を禁止します。",
      h4: "4. 免責事項",
      p4: "当サイトの素材は「現状有姿」で提供されます。明示的または黙示的を問わず、保証は一切行いません。",
      h5: "5. 責任の制限",
      p5: "当サイトまたはそのサプライヤーは、当サイトの素材の使用または使用不能から生じるいかなる損害（データ損失、逸失利益など）についても一切の責任を負いません。",
      h6: "6. 準拠法",
      p6: "当ウェブサイトの利用および利用から生じる紛争は、当国の法律に準拠するものとします。"
    }
  };

  const t = translations[locale] || translations.en;

  return (
    <>
      <Helmet>
        <title>{t.title} | Versant Practice Test</title>
        <meta name="description" content="Read the terms and conditions for using the Versant Practice Test website." />
      </Helmet>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-10 rounded-lg shadow-md">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-6">{t.title}</h1>
          <div className="prose prose-lg max-w-none">
            <p>{t.welcome}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h1}</h2>
            <p>{t.p1}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h2}</h2>
            <p>{t.p2}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h3}</h2>
            <p>{t.p3}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h4}</h2>
            <p>{t.p4}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h5}</h2>
            <p>{t.p5}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h6}</h2>
            <p>{t.p6}</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
